/*
 * @Date: 2022-09-14 10:03:23
 * @LastEditors: kinfai
 * @Description: 聊天
 * @LastEditTime: 2022-09-17 16:24:49
 * @FilePath: \my-app\src\axios\chat\index.js
 */
import service from "../index";

export default {
    // 获取分配客服
    getOnlineKf(url = "api/v1/common/chat/randomOnlineKefu", method = 'get', data) {
        return service({
            url, method, data,
            isTourists: true,
            isCompany: true
        })
    },
    // 获取客服列表
    getKf(url = "api/v1/common/chat/listOnlineKefu", method = 'get', data) {
        return service({
            url, method, data,
            isTourists: true,
            isCompany: true
        })
    },
    // 传话问答
    emitTurms(data, url = 'api/v1/common/chat/sayHelo', method = 'post') {
        return service({
            url, method, data,
            isTourists: true,
            isCompany: true
        })
    },
    // 获取频道配置
    getCompanyInfo(url = 'api/v1/common/chat/channelConf', method = 'get', data) {
        return service({
            url, method, data,
            isTourists: true,
            isCompany: true
        })
    },
    // 客服信息
    getKefuInfo(data, url = 'api/v1/common/chat/kefuInfo', method = 'get') {
        return service({
            url, method, data,
            isTourists: true,
            isCompany: true
        })
    },
    // 获取游客id
    getTouristsId(data, url = '/api/v1/common/chat/touristsId', method = 'get') {
        return service({
            url,
            method,
            data,
            isTourists: true,
            isCompany: true
        })
    }
}
